/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Box, Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import Toast from "../../../components/common/Toast";
import TransferTable from "../../../components/common/new/AccordianTable/TransferTable";
import ToggleStructure from "../../../components/Header/ToggleStructure/ToggleStructure";
import {
  INTIATE_VIEW_INTRODUCTION_DATA,
  SET_PENDING_TRANSFER_TYPE,
  SET_SELECTED_INTRODUCTION,
} from "../../../redux/actionTypes/dashboard";
import IntroductionAPI from "../../../services/api/introductionForm";
import Styles from "./styles";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import { Constants } from "../../../contants";
import { DEFAULT_TRANFER_TYPE } from "../../../redux/reducers/dashboard";
import { performOperation } from "../../member/MemberSearch/utils";
import { introductionLoading } from "../../../redux/selectors/introduction";
import Loader from "../../../components/common/Loader/Loader";
import { selectOSKeysByUserRole } from "../../../redux/selectors/user";
import { formDataToObject } from "../../../utils/helper";
// import InitiatorOrganizationSearch from "../../friend/FriendTransferRequest/InitiatorOrganizationSearch";
// import TargetOrganizationSearch from "../../friend/FriendTransferRequest/targetOrganizationSearch";
import PersonalDetailsSearch from "../introductionPending/PersonalDetailsSearch";
import OrganizationSearch from "../../member/MemberSearch/OrganizationSearch";

export default function ViewIntroduction() {
  const TITLE = "View Introduction - BSG";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);

  const [showToast, setShowToast] = useState(null);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [appliedFilterParams, setAppliedFilterParams] = useState({});

  const introductionData = useSelector((state) => state.view_introduction.data);
  const transferType = useSelector(
    (state) => state.dashboard.transferPendingType
  );
  const paginationInfo = useSelector(
    (store) => store.view_introduction.paginationInfo
  );

  const isLoading = useSelector(introductionLoading);

  const handleForward = (data) => {
    dispatch({
      type: SET_SELECTED_INTRODUCTION,
      payload: { ...data, id: data.introductionId },
    });
    navigate(`/introduction/view-remarks/forward/${data.introductionId}`);
  };

  const fetchIntroductionData = async (
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE,
    filters = appliedFilterParams
  ) => {
    dispatch({
      type: INTIATE_VIEW_INTRODUCTION_DATA,
      payload: {
        type: transferType,
        pageNumber,
        pageSize,
        ...filters,
      },
    });
  };

  const onPaginationClick = (pageNumber) => {
    const { pageSize } = paginationInfo;
    fetchIntroductionData(pageNumber, pageSize, appliedFilterParams);
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    fetchIntroductionData(0, newPageSize, appliedFilterParams);
  };

  const handleReject = (data) => {
    dispatch({
      type: SET_SELECTED_INTRODUCTION,
      payload: { ...data, id: data.introductionId },
    });
  };

  const handleRemarks = (data) => {
    dispatch({
      type: SET_SELECTED_INTRODUCTION,
      payload: { ...data, id: data.introductionId },
    });
    navigate(`/remarks/introduction/${data.introductionId}`);
  };

  const handleCancel = async (selectedIntro) => {
    try {
      await IntroductionAPI.cancelIntro({
        data: {
          introductionIds: [selectedIntro.introductionId],
        },
      });
      setShowToast({
        message: "Cancel Successfully",
        severity: "success",
      });
      fetchIntroductionData(0, paginationInfo.pageSize, appliedFilterParams);
    } catch (error) {
      setShowToast({
        message: error.message,
        severity: "error",
      });
      Sentry.captureException(error);
    }
  };

  const onRadioChange = (evt) => {
    dispatch({
      type: SET_PENDING_TRANSFER_TYPE,
      payload: evt.target.value,
    });
  };

  const onSubmitSearch = (e) => {
    e.preventDefault();
    if (!formRef.current) return;
    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    // Clean empty values
    const cleanedFilters = {};
    Object.keys(formData).forEach((key) => {
      if (
        formData[key] !== undefined &&
        formData[key] !== null &&
        String(formData[key]).trim() !== ""
      ) {
        cleanedFilters[key] = formData[key];
      }
    });

    setAppliedFilterParams(cleanedFilters);
    fetchIntroductionData(
      0,
      paginationInfo.pageSize || Constants.DEFAULT_PAGE_SIZE,
      cleanedFilters
    );
  };

  const handleClearFilters = () => {
    if (formRef.current) {
      const inputs = formRef.current.querySelectorAll("input, select");
      inputs.forEach((input) => {
        input.value = "";
        if (input.blur) input.blur();
      });
    }
    setAppliedFilterParams({});
    fetchIntroductionData(
      0,
      paginationInfo.pageSize || Constants.DEFAULT_PAGE_SIZE,
      {}
    );
  };

  useEffect(() => {
    fetchIntroductionData(
      0,
      paginationInfo.pageSize || Constants.DEFAULT_PAGE_SIZE,
      appliedFilterParams
    );
  }, [transferType]);

  useEffect(() => {
    // Reset Pending Transfer type
    return () =>
      dispatch({
        type: SET_PENDING_TRANSFER_TYPE,
        payload: DEFAULT_TRANFER_TYPE,
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div style={Styles.container}>
        {/* Advanced Search Header Toggle & Clear Filters */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "12px",
          }}
        >
          <div
            onClick={() => setShowAdvancedSearch((prev) => !prev)}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              fontWeight: "600",
              fontSize: "15px",
              gap: "6px",
              color: "#1976d2",
              userSelect: "none",
            }}
          >
            <span style={{ fontWeight: "700", fontSize: "16px" }}>
              {showAdvancedSearch ? "−" : "+"}
            </span>
            <span>Advanced Search</span>
          </div>

          {showAdvancedSearch && (
            <Button
              onClick={handleClearFilters}
              variant="outlined"
              color="secondary"
              sx={{
                textTransform: "none",
                height: "24px",
                fontSize: "13px",
                fontWeight: "600",
                padding: "2px 8px !important",
              }}
            >
              Clear Filters
            </Button>
          )}
        </div>

        {/* Filter Section (Only rendered when Advanced Search is opened) */}
        {showAdvancedSearch && (
          <div style={{ marginBottom: "16px" }}>
            <form
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                width: "100%",
              }}
              onSubmit={onSubmitSearch}
              ref={formRef}
            >
              <div>
                <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                  Initiating Organization Structure
                </div>
                <OrganizationSearch
                  formRef={formRef}
                  disabledOSKeys={disabledOSKeys}
                />
              </div>

              <div>
                <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                  Personal Details
                </div>
                <PersonalDetailsSearch disabledOSKeys={disabledOSKeys} />
              </div>

              <div
                style={{
                  display: "flex",
                  justify: "flex-end",
                  paddingTop: "10px",
                  marginRight: "10px",
                }}
              >
                <Button type="submit" variant="contained" color="primary">
                  Search
                </Button>
              </div>
            </form>
          </div>
        )}

        {/* Tab & Results Table */}
        <Box
          sx={{
            display: "flex",
            justify: "space-between",
            mb: "1rem",
          }}
        >
          <Box style={Styles.left}>
            <Box style={Styles.radioContainer}>
              <ToggleStructure
                value={transferType}
                label="Introductions"
                handleChange={onRadioChange}
              />
            </Box>
          </Box>
        </Box>
        <TransferTable
          data={introductionData}
          handleForward={handleForward}
          handleReject={handleReject}
          handleRemarks={handleRemarks}
          handleCancel={handleCancel}
        />
        {introductionData.length ? (
          <Box style={Styles.pagination}>
            <Pagination
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box>
        ) : (
          !isLoading && (
            <Box style={Styles.emptyContainer}>
              <h1 style={Styles.noDataMsg}>No Results</h1>
            </Box>
          )
        )}
        {isLoading && <Loader />}
        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => {
            setShowToast(null);
          }}
        />
      </div>
    </>
  );
}
